import { Tab, TabProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTab = styled(Tab)<TabProps & { active?: boolean }>(({ theme, active }) => ({
    fontSize: '20px',
    fontWeight: active ? 500 : 300,
    color: theme.palette.secondary.main
}));
